import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const DISASSOCIATE_CONTACT = createAsyncActionTypes('DISASSOCIATE_CONTACT');
export const FETCH_CURRENT_CRM_OWNER = createAsyncActionTypes('FETCH_CURRENT_CRM_OWNER');
export const FETCH_OWNER_BY_USER_ID = createAsyncActionTypes('FETCH_OWNER_BY_USER_ID');
export const FETCH_CONTACT = createAsyncActionTypes('FETCH_CONTACT');
export const ASSOCIATE_CONTACT = createAsyncActionTypes('ASSOCIATE_CONTACT');
export const FETCH_TICKET_DATA = createAsyncActionTypes('FETCH_TICKET_DATA');
export const GET_TICKET_SOURCES = createAsyncActionTypes('GET_TICKET_SOURCES');
export const FETCH_DELIVERY_IDENTIFIERS = createAsyncActionTypes('FETCH_DELIVERY_IDENTIFIERS');